import {IMenuItemRenderer, IRenderMenuItemOptions} from "./menu-item.renderer.interface";
import React from "react";
import {
    IMenuItemAction,
    IMenuItemExecuteOptions
} from "../../menu-item-action-factory/menu-item-action.interface";
import {MenuItemKey} from "../../configurations/config-data-sections/generated-config-const";
import {NullableUndefinedString} from "../../../../common/types/nullable-types";
import {IconSourceConfiguration} from "../../configurations/config-data-sections/icon-source.configuration";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {
    IMenuItemConfigReader,
    MenuItemConfigurationExtended
} from "../menu-item-config-reader/menu-item-config-reader.interface";
import {IMenuItemActionFactoryService} from "../../menu-item-action-factory/menu-item-action-factory.service.interface";


export abstract class MenuItemRendererBase implements IMenuItemRenderer {
    constructor(public readonly key: MenuItemKey,
                private readonly configReader: IMenuItemConfigReader,
                protected readonly services: IServiceFactoryExtended,
                protected readonly menuItemActionFactory: IMenuItemActionFactoryService) {
        this.menuItemAction = this.menuItemActionFactory.getMenuItemAction(this.key, this.configReader);
    }

    protected abstract _createReactElement(options?: IRenderMenuItemOptions): React.ReactElement;


    private _config: MenuItemConfigurationExtended | null = null;
    protected _lastRenderOptions: IRenderMenuItemOptions | undefined = undefined;

    private get config(): MenuItemConfigurationExtended {
        if(!this._config) {
            this._config = this.configReader.getMenuItemConfig(this.key);
        }

        return this._config;
    }

    private readonly menuItemAction: IMenuItemAction;

    renderMenuItem(options?: IRenderMenuItemOptions): React.ReactElement {
        this._lastRenderOptions = options;
        return this._createReactElement(options);
    }

    execute(options?: IMenuItemExecuteOptions): Promise<void> {
        if(this._lastRenderOptions?.onBeforeClick) {
            this._lastRenderOptions.onBeforeClick();
        }
        return this.menuItemAction.execute(options);
    }


    get text(): string {
        return this.services.translation.translate(this.config.text);
    }

    get sideText(): NullableUndefinedString {
        return null;
    }

    get imageOnlyRendering(): boolean {
        return this.config.imageOnlyRendering ?? false;
    }

    protected _shouldDisplay(): boolean {
        return this.config.display ?? true;
    }

    get display(): boolean {
        return this._shouldDisplay();
    }

    get isMatchToCurrentUrl(): boolean {
        return this.menuItemAction.isMatchToCurrentUrl;
    }

    get iconSource(): IconSourceConfiguration {
        return this.config.menuItemIconSource ?? "themeIcons";
    }

    get icon(): NullableUndefinedString {
        return this.config.menuItemIcon;
    }

    get iconAltText(): NullableUndefinedString {
        return this.services.translation.translate(this.config.menuItemIconAltText);
    }

    getLinkUrl(): NullableUndefinedString {
        return this.menuItemAction.getLinkUrl();
    }


}